import { ConfirmDialog, FlexColumn, FlexRow, FormControlLabel, Switch, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React from "react";
import BackgroundColorPicker from "../../toolbarComponents/BackgroundColorPicker";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { GenerateImageFormat } from "../snapshotUtils";

const BackgroundSettings = observer(() => {
	const store = useSnapshotTemplateStore();
	const { 
		use3DEnvironmentAsBackground,
		selectedBackgroundColor,
		set3DEnvironmentAsBackground,
		setSelectedBackgroundColor,
		setImageFormat,
		setForceCloseJpgTransparentErrorModal,
		showJpgHasTransparentColorError, 
	} = store;

	return (
		<FlexColumn gap={2}>
			<FlexRow>
				<Text bold res="BackgroundSettings" />
				<Text color="error" text="*" />
			</FlexRow>
			<FormControlLabel
				control={(
					<Switch
						checked={use3DEnvironmentAsBackground}
						onChange={set3DEnvironmentAsBackground}
					/>
				)}
				labelPlacement="end"
				res="3DEnvironmentAsBackground"
				sx={{
					width: "fit-content",
				}}
			/>
			<FormControlLabel
				control={(
					<BackgroundColorPicker onClose={setSelectedBackgroundColor} presetBackgroundColor={selectedBackgroundColor} />
				)}
				labelPlacement="end"
				res="BackgroundColor"
				sx={{
					visibility: use3DEnvironmentAsBackground ? "hidden" : "visible",
					width: "fit-content",
					"& .MuiFormControlLabel-label" : {
						marginLeft: 2,
					},
				}}
			/>
			<ConfirmDialog 
				confirmRes="BUTTON_CONVERT" 
				maxWidth="sm"
				messageRes="3DTransparentJpgErrorMessage"
				onCancel={() => setForceCloseJpgTransparentErrorModal(true)}
				onConfirm={() => setImageFormat(null, GenerateImageFormat.PNG)}
				open={showJpgHasTransparentColorError}
				titleRes="3DTransparentJpgErrorTitle"
				width="100%"
			/>
		</FlexColumn>
	);
});

export default BackgroundSettings;